import type { AppInfo } from '@core/application/ApplicationManager'
import { FileManagerList, getMicroAppIdFromUrl, MicroAppId } from '@core/application/ApplicationConstants'
import { computed, ref, shallowRef } from 'vue'
import { menuAppChineseNameMap } from '@core/TrackConstants'
import { createSharedComposable } from '@vueuse/core'
import { PATH_SEPARATOR } from '@core/Constants'
import type { AppMenuInfo } from '@core/menus/MenuManager'

export const useActiveMenuItem = () => {
  const activeAppId = ref<MicroAppId | undefined>()

  const appMenuList = shallowRef<AppInfo[]>([])
  const categoryMenuList = shallowRef<AppMenuInfo[]>([])

  const setAppMenuList = (list: AppInfo[], MenuList: AppMenuInfo[]) => {
    appMenuList.value = list
    categoryMenuList.value = MenuList
  }

  const activeItem = computed(() => getActiveItem())

  const needShowNavigatorBar = computed(
    () =>
      categoryMenuList.value.find((categoryMenu) => categoryMenu.category === activeItem.value?.category)
        ?.haveMoreThanOneSubMenuItems ?? true
  )

  const getActiveItem = (): AppInfo | undefined => {
    if (isFileManager.value) {
      return appMenuList.value.find((item) => item.id === MicroAppId.FILE_MANAGER)
    }

    return appMenuList.value.find((item) => item.id === activeAppId.value)
  }

  const updateCurrentAppId = (path: string = window.location.href) =>
    (activeAppId.value = getMicroAppIdFromUrl(path, PATH_SEPARATOR))

  const isFileManager = computed(() => activeAppId.value !== undefined && FileManagerList.includes(activeAppId.value))
  // 当前选中应用的追踪中文名，仅用于埋点使用
  const currentAppTrackName = computed(() =>
    activeItem.value?.trackId ? menuAppChineseNameMap.get(activeItem.value.trackId) : ''
  )

  return {
    updateCurrentAppId,
    setAppMenuList,
    activeItem,
    activeAppId,
    isFileManager,
    currentAppTrackName,
    needShowNavigatorBar,
  }
}

export const useSharedActiveMenuItem = createSharedComposable(useActiveMenuItem)
